/* eslint-disable max-len */
import EthQuestion from 'images/coin-pages/questions/eth.svg'

import { ECoinPageParagraphTypes, ICoinPageData } from 'pages/loans/[coin]/assets/page-data/types'

export const ethPage: ICoinPageData = {
  title: 'coin_343',
  description: 'coin_344',
  metaTitle: 'eth_loan_meta_title',
  metaDescription: 'eth_loan_meta_desc',
  calculatorTitle: 'borrow_against_eth',
  h1: (t) => (
    <>
      <span
        dangerouslySetInnerHTML={{ __html: t('get_eth_loan') }}
      />
    </>
  ),
  questionsBlock: {
    image: EthQuestion,
    questions: [
      {
        title: 'coin_345',
        answer: 'coin_346',
      },
      {
        title: 'coin_347',
        answer: 'coin_348',
      },
      {
        title: 'coin_349',
        answer: 'coin_350',
      },
      {
        title: 'coin_351',
        answer: 'coin_352',
      },
    ],
  },
  whatIs: {
    text: [],
    learnMoreTitle: 'learn_more_about_name_lending',
    paragraphs: [
      {
        title: 'coin_355',
        text: ['coin_360'],
      },
      {
        title: 'coin_356',
        text: ['coin_361', 'coin_362', 'coin_363', 'coin_365'],
        type: ECoinPageParagraphTypes.ul,
      },
      {
        title: 'coin_358',
        text: ['coin_367', 'coin_368', 'coin_369', 'coin_370'],
        type: ECoinPageParagraphTypes.ul,
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/what-is-crypto-lending-platform-coinrabbit/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/07/photo_2021-07-23_20-28-31.jpg',
        imageAlt: 'Ethereum (ETH) crypto loans review 5',
      },
      {
        link: 'https://coinrabbit.io/blog/how-crypto-assets-are-secured/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1185/https://coinrabbit.io/blog/wp-content/uploads/2021/08/integration-52CR_LQ.png',
        imageAlt: 'Ethereum (ETH) crypto loans review 6',
      },
      {
        link: 'https://coinrabbit.io/blog/crypto-lending-growing-market-emerges-opportunities/',
        image:
          'https://cdn.shortpixel.ai/client/q_lossless,ret_img,w_1200/https://coinrabbit.io/blog/wp-content/uploads/2021/05/photo_2021-05-26_21-10-19.jpg',
        imageAlt: 'Ethereum (ETH) crypto loans review 7',
      },
    ],
  },
  videoId: 'yFtj65yI8R4',
  videoTitle: 'coin_359',
}
